import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class LicenceService {

  LICENCE_API_BASE_URL= SERVER_API_URL+'licences/';

  constructor(
    private http: HttpClient
  ) { }

  getLicencesHome(regionCodes: string[]): Observable<any> {
    let options: HttpParams = new HttpParams();
    for (let regionCode of regionCodes) {
      options=options.append('regionCode',regionCode);
    }
    return this.http.get(this.LICENCE_API_BASE_URL + 'home', { params: options});
  }

  getLicencesByBand(regionCodes: string[], bandCode: string) : Observable<any> {
    let options: HttpParams = new HttpParams();
    for (let regionCode of regionCodes) {
      options=options.append('regionCode',regionCode);
    }
    return this.http.get<any>(this.LICENCE_API_BASE_URL+'band/'+bandCode, { params: options});
  }

  getLicencesByBandGroup(regionCodes: string[], bandGroup: string) : Observable<any> {
    let options: HttpParams = new HttpParams();
    for (let regionCode of regionCodes) {
      options=options.append('regionCode',regionCode);
    }
    return this.http.get<any>(this.LICENCE_API_BASE_URL+'bandGroup/'+bandGroup, { params: options});
  }

  getLicencesByCountry(countryCode: string) : Observable<any> {
    return this.http.get<any>(this.LICENCE_API_BASE_URL+'country/'+countryCode);
  }

  getLicencesByCountryBand(countryCode: string, bandCode: string) : Observable<any> {
    return this.http.get<any>(this.LICENCE_API_BASE_URL+'country/'+countryCode+'/band/'+bandCode);
  }

  getLicencesByCountryBandGroup(countryCode: string, bandGroup: string) : Observable<any> {
    return this.http.get<any>(this.LICENCE_API_BASE_URL+'country/'+countryCode+'/bandGroup/'+bandGroup);
  }

}
